"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var distributionRouter = {
  path: '/distribution',
  component: _layout.default,
  redirect: '/distribution/overview',
  name: 'Distribution',
  meta: {
    title: '淘客',
    icon: 'clipboard'
  },
  children: [{
    path: 'promoter-management',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/distribution/alliance/ParentView'));
      });
    },
    redirect: '/distribution/promoter-management/promoters',
    name: 'DistributionPromoterManagement',
    meta: {
      title: '淘客管理',
      icon: ''
    },
    children: [{
      path: 'promoters',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/distribution/alliance/promoter-center/index'));
        });
      },
      name: 'DistributionPromoterList',
      meta: {
        title: '淘客列表',
        icon: ''
      }
    }, {
      path: 'settings',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/distribution/alliance/config/index'));
        });
      },
      name: 'DistributionSettings',
      meta: {
        title: '淘客设置',
        icon: ''
      }
    }, {
      path: 'withdrawals',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/distribution/alliance/withdraw/index'));
        });
      },
      name: 'DistributionPromoterWithdrawals',
      meta: {
        title: '淘客提现申请',
        icon: '',
        accountRole: 'PROMOTER'
      }
    }]
  }, {
    path: 'leader-management',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/distribution/alliance/ParentView'));
      });
    },
    redirect: '/distribution/leader-management/leaders',
    name: 'DistributionLeaderManagement',
    meta: {
      title: '团长管理',
      icon: ''
    },
    children: [{
      path: 'leaders',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/distribution/alliance/leader/index'));
        });
      },
      name: 'DistributionLeaderList',
      meta: {
        title: '团长列表',
        icon: ''
      }
    }, {
      path: 'verify-limit',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/distribution/alliance/verify-limit/index'));
        });
      },
      name: 'DistributionLeaderVerifyLimit',
      meta: {
        title: '积分核销限额',
        icon: ''
      }
    }, {
      path: 'verify-records',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/distribution/alliance/verify/index'));
        });
      },
      name: 'DistributionLeaderVerifyRecords',
      meta: {
        title: '积分核销记录',
        icon: ''
      }
    }, {
      path: 'withdrawals',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/distribution/alliance/withdraw/index'));
        });
      },
      name: 'DistributionLeaderWithdrawals',
      meta: {
        title: '团长提现申请',
        icon: '',
        accountRole: 'LEADER'
      }
    }]
  }, {
    path: 'agent-management',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/distribution/alliance/ParentView'));
      });
    },
    redirect: '/distribution/agent-management/regions',
    name: 'DistributionAgentManagement',
    meta: {
      title: '代理',
      icon: ''
    },
    children: [{
      path: 'regions',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/distribution/alliance/region/index'));
        });
      },
      name: 'DistributionRegionAgents',
      meta: {
        title: '区域与代理',
        icon: ''
      }
    }, {
      path: 'profits',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/distribution/alliance/agent-profit/index'));
        });
      },
      name: 'DistributionAgentProfits',
      meta: {
        title: '代理利润分成',
        icon: ''
      }
    }]
  }, {
    path: 'zone-management',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/distribution/alliance/ParentView'));
      });
    },
    redirect: '/distribution/zone-management/stores',
    name: 'DistributionZoneManagement',
    meta: {
      title: '门店专区',
      icon: ''
    },
    children: [{
      path: 'stores',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/distribution/storeManage/index'));
        });
      },
      name: 'DistributionStoreManagement',
      meta: {
        title: '门店管理',
        icon: ''
      }
    }, {
      path: 'products',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/distribution/alliance/distribution-product/index'));
        });
      },
      name: 'DistributionZoneProducts',
      meta: {
        title: '淘客商品',
        icon: ''
      }
    }, {
      path: 'points',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/distribution/alliance/points/index'));
        });
      },
      name: 'DistributionPointsReconciliation',
      meta: {
        title: '积分对账',
        icon: ''
      }
    }, {
      path: 'commissions',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/distribution/alliance/commission/index'));
        });
      },
      name: 'DistributionCommissionDetails',
      meta: {
        title: '分账明细',
        icon: ''
      }
    }]
  }, {
    path: 'overview',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/distribution/overview/index'));
      });
    },
    name: 'DistributionOverview',
    meta: {
      title: '淘客概况',
      icon: ''
    }
  }, {
    path: 'distributor',
    name: 'DistributorManage',
    meta: {
      title: '淘客商管理',
      icon: ''
    },
    children: [{
      path: 'pending',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/distribution/distributor/pending/index'));
        });
      },
      name: 'DistributorPending',
      meta: {
        title: '待审核',
        icon: ''
      }
    }, {
      path: 'all',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/distribution/distributor/all/index'));
        });
      },
      name: 'DistributorAll',
      meta: {
        title: '全部淘客商',
        icon: ''
      }
    }]
  }, {
    path: 'level',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/distribution/level/index'));
      });
    },
    name: 'DistributionLevel',
    meta: {
      title: '淘客等级',
      icon: ''
    }
  }, {
    path: 'goods',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/distribution/goods/index'));
      });
    },
    name: 'DistributionGoods',
    meta: {
      title: '淘客商品',
      icon: ''
    }
  }, {
    path: 'store-info',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/distribution/storeInfo/index'));
      });
    },
    name: 'DistributionStoreInfo',
    meta: {
      title: '门店信息',
      icon: ''
    }
  }, {
    path: 'store-contract',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/distribution/storeContract/index'));
      });
    },
    name: 'DistributionStoreContract',
    meta: {
      title: '我的合同',
      icon: ''
    }
  }, {
    path: 'store-product',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/distribution/storeProduct/index'));
      });
    },
    name: 'DistributionStoreProduct',
    meta: {
      title: '门店商品',
      icon: ''
    }
  }, {
    path: 'store-rule',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/distribution/storeRule/index'));
      });
    },
    name: 'DistributionStoreRule',
    meta: {
      title: '商品规格',
      icon: ''
    }
  }, {
    path: 'store-reply',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/distribution/storeReply/index'));
      });
    },
    name: 'DistributionStoreReply',
    meta: {
      title: '商品评论',
      icon: ''
    }
  }, {
    path: 'store-guarantee',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/distribution/storeGuarantee/index'));
      });
    },
    name: 'DistributionStoreGuarantee',
    meta: {
      title: '保障服务',
      icon: ''
    }
  }, {
    path: 'store-category',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/distribution/storeCategory/index'));
      });
    },
    name: 'DistributionStoreCategory',
    meta: {
      title: '商品分类',
      icon: ''
    }
  }, {
    path: 'store-brand',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/distribution/storeBrand/index'));
      });
    },
    name: 'DistributionStoreBrand',
    meta: {
      title: '品牌管理',
      icon: ''
    }
  }, {
    path: 'store-library',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/distribution/storeLibrary/index'));
      });
    },
    name: 'DistributionStoreLibrary',
    meta: {
      title: '门店专区',
      icon: ''
    }
  }, {
    path: 'store-order',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/distribution/storeOrder/index'));
      });
    },
    name: 'DistributionStoreOrder',
    meta: {
      title: '门店订单',
      icon: ''
    }
  }, {
    path: 'store-card',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/distribution/storeCard/index'));
      });
    },
    name: 'DistributionStoreCard',
    meta: {
      title: '卡券核销',
      icon: ''
    }
  }, {
    path: 'store-coupon',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/distribution/storeCoupon/index'));
      });
    },
    name: 'DistributionStoreCoupon',
    meta: {
      title: '门店优惠券',
      icon: ''
    }
  }, {
    path: 'store-refund',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/distribution/storeRefund/index'));
      });
    },
    name: 'DistributionStoreRefund',
    meta: {
      title: '售后管理',
      icon: ''
    }
  }, {
    path: 'order',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/distribution/order/index'));
      });
    },
    name: 'DistributionOrder',
    meta: {
      title: '淘客订单',
      icon: ''
    }
  }, {
    path: 'withdraw',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/distribution/withdraw/index'));
      });
    },
    name: 'DistributionWithdraw',
    meta: {
      title: '淘客提现',
      icon: ''
    }
  }, {
    path: 'setting',
    name: 'DistributionSetting',
    meta: {
      title: '淘客设置',
      icon: ''
    },
    children: [{
      path: 'basic',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/distribution/setting/basic/index'));
        });
      },
      name: 'DistributionBasicSetting',
      meta: {
        title: '基础设置',
        icon: ''
      }
    }, {
      path: 'agreement',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/distribution/setting/agreement/index'));
        });
      },
      name: 'DistributionAgreement',
      meta: {
        title: '申请协议',
        icon: ''
      }
    }, {
      path: 'withdrawConfig',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/distribution/setting/withdrawConfig/index'));
        });
      },
      name: 'DistributionWithdrawSetting',
      meta: {
        title: '提现设置',
        icon: ''
      }
    }, {
      path: 'text',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/distribution/setting/text/index'));
        });
      },
      name: 'DistributionTextSetting',
      meta: {
        title: '文字设置',
        icon: ''
      }
    }]
  }]
};
var _default = exports.default = distributionRouter;